import { computed } from 'vue'
import { useVueI18n } from '../locales'
import { DATE_FIELD_DATE_VALIDATION } from '../types'
import { ELEMENTS_LOOKUP } from './elements'

const t = useVueI18n()
export enum REDIRECTS_TYPES {
  NEW_TAB = 'newTab',
  EXISTING_TAB = 'existingTab',
}

export enum USER_ROLE_TYPE {
  ACCOUNT = 'account',
  AGENCY = 'agency',
}

export enum USER_ROLE {
  ADMIN = 'admin',
  USER = 'user',
}

export const fillableFields = new Set([
  ELEMENTS_LOOKUP.TEXT_FIELD,
  ELEMENTS_LOOKUP.DATE_FIELD,
  ELEMENTS_LOOKUP.SAVE_CARD_DETAILS,
])

export const selectableFields = new Set([ELEMENTS_LOOKUP.CHECKBOX])

export const assignableFields = new Set([
  ELEMENTS_LOOKUP.TEXT_FIELD,
  ELEMENTS_LOOKUP.DATE_FIELD,
  ELEMENTS_LOOKUP.SIGNATURE,
  ELEMENTS_LOOKUP.INITIALS_FIELD,
  ELEMENTS_LOOKUP.CHECKBOX,
  ELEMENTS_LOOKUP.SAVE_CARD_DETAILS,
])

export const dateFieldDateValidationOptions = () => {
  const t = useVueI18n()
  return computed(() => [
    {
      label: t('common.anyDate'),
      value: DATE_FIELD_DATE_VALIDATION.ANY,
    },
    {
      label: t('common.pastDate'),
      value: DATE_FIELD_DATE_VALIDATION.PAST_DATE,
    },
    {
      label: t('common.futureDate'),
      value: DATE_FIELD_DATE_VALIDATION.FUTURE_DATE,
    },
    {
      label: t('common.todayDate'),
      value: DATE_FIELD_DATE_VALIDATION.TODAYS_DATE,
    },
  ])
}
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
export const dateFormatOptions = [
  { label: 'YYYY-MM-DD', value: 'yyyy-MM-dd' },
  { label: 'MM-DD-YYYY', value: 'MM-dd-yyyy' },
  { label: 'DD-MM-YYYY', value: 'dd-MM-yyyy' },
  { label: 'YYYY / MM / DD', value: 'yyyy / MM / dd' },
  { label: 'MM / DD / YYYY', value: 'MM / dd / yyyy' },
  { label: 'DD / MM / YYYY', value: 'dd / MM / yyyy' },
  { label: 'YYYY.MM.DD', value: 'yyyy.MM.dd' },
  { label: 'MM.DD.YYYY', value: 'MM.dd.yyyy' },
  { label: 'DD.MM.YYYY', value: 'dd.MM.yyyy' },
  { label: 'MMM DD, YYYY', value: 'MMM dd, yyyy' },
  { label: 'DD MMM YYYY', value: 'dd MMM yyyy' },
  { label: 'D MMMM YYYY', value: 'd MMMM yyyy' },
  { label: 'MMMM D, YYYY', value: 'MMMM d, yyyy' },
]

export const redirectTypes = [
  {
    get label() { return t('common.existingTab') },
    value: REDIRECTS_TYPES.EXISTING_TAB,
    labelKey: 'common.existingTab',
  },
  {
    get label() { return t('common.openNewTab') },
    value: REDIRECTS_TYPES.NEW_TAB,
    labelKey: 'common.openNewTab',
  },
]
